import Http from '../api/http';

export default class Oapi extends Http {
  constructor() {
    super();
  }
  /***********登录管理***************/
  /**
   * 获取客服手机
   * @param {Array} model -  model
   */
  oapi_checkQQ() {
    return super.post('oapi/checkQQ', ...arguments);
  }
  /**
   * 获取活动消息详情
   * @param {string} mid -  mid
   * @param {Array} model -  model
   */
  oapi_getMessageContent() {
    return super.post('oapi/getMessageContent', ...arguments);
  }
  /**
   * getts
   * @param {Array} model -  model
   */
  oapi_getts() {
    return super.post('oapi/getts', ...arguments);
  }
  /**
   * 登录
   * @param {string} account -  用户名
   * @param {string} vCode -  验证码
   * @param {integer} autoLogin -  是否自动登录
   */
  oapi_login() {
    return super.post('oapi/login', ...arguments);
  }
  /**
   * 退出登录
   * @param {string} token -  token
   * @param {Array} model -  model
   */
  oapi_logout() {
    return super.post('oapi/logout', ...arguments);
  }
  /**
   * 推荐页面注册
   * @param {Array} req -  req
   */
  oapi_recommendRegister() {
    return super.post('oapi/recommendRegister', ...arguments);
  }
  /**
   * 登录
   * @param {string} openid -  openid
   * @param {string} nickname -  nickname
   * @param {string} face -  face
   * @param {Array} model -  model
   */
  oapi_weixinVerify() {
    return super.post('oapi/weixinVerify', ...arguments);
  }
  /**
   * 检查是否微信公众号登录
   */
  oapi_checkLogin() {
    return super.post('oapi/checkLogin', ...arguments);
  }
  /**
   * 获取手机验证码
   * @param {string} phone -  手机号码
   */
  messageCode_getVCode() {
    return super.post('messageCode/getVCode', ...arguments);
  }
}
